<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="color"
      d="M43.7,3.9L4.9,0.6C4,0.6,2.9,1.2,2.9,2.3L1.5,18.4v0.5l-0.7,7c0,1.1,0.7,1.9,1.7,1.9L22.6,30l1.4,0.1l17.4,1.5
        c1.1,0,1.9-0.7,1.9-1.7l2-23.5C45.5,5,44.7,4.2,43.7,3.9z M17.3,25.8c-0.1,0-0.2,0-0.2-0.2c0-0.2,0.2-2.2,0.3-2.4
        c0-0.1,0.2-0.2,0.2-0.2c1.4-1.1,2.3-2.8,2.5-5.8c0-0.5,0.4-0.4,0.4,0C20.3,20.8,20.3,23.6,17.3,25.8z M27.5,26.6
        c0,0.1-0.1,0.2-0.3,0.2c-1.8-0.2-3.8-1.2-4.6-3.1c-0.6-2.1-0.5-4.3,0.1-6.6c0.2-0.7,0.6-0.6,0.5,0.1c-0.3,3.1,0.3,4.9,1.6,5.7
        c0.8,0.5,1.6,0.9,2.6,1.1c0.2,0.1,0.2,0.2,0.2,0.3C27.7,25,27.6,25.9,27.5,26.6z M34.2,19c-2,1.5-4.9,1.9-6.9,2.4
        c-0.1,0-0.4,0-0.4-0.4c0-0.4,0.2-1.6,0.3-1.9c0-0.3,0.2-0.4,0.2-0.4c2.3-0.4,4.2-0.6,6-1.8c0.3-0.2,0.6-0.6,0.1-1.1
        c-0.6-0.6-2.4-2.2-6.3-2.5c-0.3,0-1.2-0.1-2.1-0.1c-1-0.1-1.4,0,1.3-1.9c0.4-0.3,0.6-0.5,0.8-0.7S28.1,9.3,26,9
        c-2.1-0.5-4.2-0.3-7.1,0.4c-2.6,0.7-5.4,1.5-6.9,3.6c-0.1,0.2-0.2,0.3-0.2,0.7c0,0.3,0.1,0.6,0.2,0.7c0.6,1.5,2.8,2.3,4.6,3.2
        c0,0,0.2,0.1,0.2,0.3c0,0.2-0.2,2.1-0.2,2.3c0,0.2-0.2,0.3-0.3,0.2c-2.1-0.9-5.4-3.6-5.6-6.6c-0.1-1.1,0.4-2.7,2.2-4.2
        c4-3,9.1-3.6,12.3-3.5c3.5,0.1,4.9,0.6,5.4,1.9c0.4,1.3-0.2,2.2-0.9,3.2c2.2,0.7,4.8,1.6,5.4,4.2C35.4,16.4,35.3,18.1,34.2,19z"
    />
  </svg>
</template>
<script>
export default {
  name: "bt-travel-card",
  props: {
    color: {
      type: String,
      default: "#4CAE44",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
